import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../lib/api';
import { formatDate } from '../../lib/format';
import AdminLayout from '../../components/AdminLayout';
import { Card } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/table';
import { StatusBadge } from '../../components/StatusBadge';

export default function AdminMembers() {
  const nav = useNavigate();
  const [members, setMembers] = useState([]);
  const [q, setQ] = useState('');
  const [filter, setFilter] = useState('');
  const load = (search='') => api.get(`/admin/members?q=${encodeURIComponent(search)}`).then(r => setMembers(r.data.members)).catch(()=>{});
  useEffect(() => { load(); }, []);

  const shown = members.filter(m => !filter || (m.membership?.status||'PENDING') === filter);

  return (
    <AdminLayout title="Members">
      <div className="flex flex-wrap gap-2 mb-4">
        <div className="flex gap-2 flex-1 min-w-[240px] max-w-md"><Input placeholder="Cari nama / email..." value={q} onChange={e => setQ(e.target.value)} onKeyDown={e => e.key==='Enter' && load(q)} data-testid="member-search-input" /><Button onClick={() => load(q)}>Cari</Button></div>
        <Select value={filter||'ALL'} onValueChange={(v)=>setFilter(v==='ALL'?'':v)}><SelectTrigger className="w-44" data-testid="member-filter"><SelectValue placeholder="Filter status" /></SelectTrigger><SelectContent><SelectItem value="ALL">Semua</SelectItem>{['PENDING','ACTIVE','EXPIRED','SUSPENDED','CANCELLED'].map(s=><SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent></Select>
      </div>
      <Card className="p-0 overflow-hidden"><div className="overflow-x-auto">
        <Table><TableHeader><TableRow><TableHead>Nama</TableHead><TableHead>Kontak</TableHead><TableHead>Referral</TableHead><TableHead>Status</TableHead><TableHead>Expiry</TableHead><TableHead>Aksi</TableHead></TableRow></TableHeader>
          <TableBody>{shown.map(m => (
            <TableRow key={m.user_id} className="cursor-pointer hover:bg-muted/40" onClick={()=>nav(`/admin/members/${m.user_id}`)}>
              <TableCell className="font-medium">{m.name}</TableCell>
              <TableCell className="text-xs">{m.email}<br/>{m.whatsapp}</TableCell>
              <TableCell className="font-mono text-xs">{m.referral_code}</TableCell>
              <TableCell><StatusBadge status={m.membership?.status || 'PENDING'} /></TableCell>
              <TableCell className="text-xs">{m.membership?.membership_expiry_date ? formatDate(m.membership.membership_expiry_date) : '-'}</TableCell>
              <TableCell><Button size="sm" variant="outline" onClick={(e)=>{e.stopPropagation(); nav(`/admin/members/${m.user_id}`);}} data-testid={`detail-${m.user_id}`}>Detail</Button></TableCell>
            </TableRow>
          ))}</TableBody>
        </Table>
      </div></Card>
    </AdminLayout>
  );
}
